import { useState } from 'react'

import { CityOption } from '../../../components/forms/SelectCity'
import { useSearchParams } from '@remix-run/react'
import { useLegalTermsCheckbox } from '../../../components/forms/LegalTerms'
import { UserSignupInput } from '../../../graphql/types.gen'
import { ZonedDateTime, getLocalTimeZone, now } from '@internationalized/date'

const useUserSignup = () => {
  const [name, setName] = useState<UserSignupInput['name']>('')
  const [searchParams] = useSearchParams()

  const searchParamEmail = searchParams.get('email')
  const [email, setEmail] = useState<UserSignupInput['email']>(
    searchParamEmail ?? '',
  )
  const [password, setPassword] = useState<UserSignupInput['password']>('')
  const [passwordConfirmation, setPasswordConfirmation] =
    useState<UserSignupInput['passwordConfirmation']>('')

  let initialBirthday = now(getLocalTimeZone()).subtract({ years: 20 })
  let [birthday, setBirthday] = useState<ZonedDateTime>(initialBirthday)
  const [city, setCity] = useState<CityOption>({
    value: 1,
    label: 'Glasgow',
  })
  const { termsAccepted, legalTermsCheckbox } = useLegalTermsCheckbox()

  const state: UserSignupInput = {
    name,
    email,
    password,
    passwordConfirmation,
    cityId: city.value,
    dateOfBirth: birthday.toAbsoluteString(),
    termsAccepted,
  }

  const setters = {
    setName,
    setEmail: searchParamEmail ? () => null : setEmail,
    setPassword,
    setPasswordConfirmation,
    setBirthday,
    setCity,
  }

  const fields = {
    name,
    email,
    password,
    passwordConfirmation,
    city,
    birthday,
  }

  return { state, setters, fields, legalTermsCheckbox }
}

export default useUserSignup
